export { Slider } from './slider'
